<template>
<q-page class="page-background">
  <div class="q-pa-lg">
    <q-card class="frosted" style="height: 45rem">
      <q-card-section horizontal style="height: 100%">
        <q-card-section id="rooms" style="width: 30em">
          <div class="text-h6 q-ml-sm">Mesaje</div>
          <q-separator class="full-width q-pa-none"></q-separator>
          <q-scroll-area ref="scrollArea" style="height: 96%; max-width: 100%">
            <div
              v-for="user in cached_users"
              :key="user"
              class="q-pt-sm q-pb-sm"
            >
              <q-item clickable v-ripple @click="SelectUser(user)">
                <q-item-section side>
                  <q-avatar rounded size="48px">
                    <img :src="user.profilepic" />
                  </q-avatar>
                </q-item-section>
                <q-item-section>
                  <q-item-label >{{ user.name }}</q-item-label>
                  <q-item-label class="text-caption">
                    <q-icon
                      v-if="user.lastmsg.author === 'Suport'"
                      name="mdi-check" color="blue-6" size="xs"
                    ></q-icon>
                    {{ user.lastmsg.data.text[0].substring(0,41) + " ..." }}
                  </q-item-label>
                </q-item-section>
              </q-item>
              <q-separator class="q-mt-sm"></q-separator>
            </div>
          </q-scroll-area>
        </q-card-section>
        <q-separator vertical />

        <q-card-section id="chat" class="full-width">
          <q-item class="col" style="border-bottom: 1.5px solid grey">
            <q-item-section side>
              <q-avatar
                v-if="Object.entries(currentUser).length != 0"
                rounded
                size="48px"
              >
                <img :src="currentUser.profilepic" />
              </q-avatar>
            </q-item-section>
            <q-item-section v-if="Object.entries(currentUser).length != 0">
              <div class="text-h6">{{ currentUser.name }}</div>
              <div class="text-caption">
                Uuid:
                <span class="text-bold">{{ currentUser.uid }}</span>
              </div>
              <div class="text-caption">
                Mail:
                <span class="text-bold">{{ currentUser.email }}</span>
              </div>
            </q-item-section>
            <q-item-section side>
              <q-btn
                v-if="Object.entries(currentUser).length != 0"
                @click="ArchiveConversation(currentUser.uid)"
                dense
                flat
                icon="mdi-archive"
              >
                <q-tooltip
                  anchor="center left"
                  self="center right"
                  :offset="[10, 10]"
                  class="bg-indigo text-body2"
                >
                  <strong>Arhiveaza</strong> aceasta conversatie
                </q-tooltip>
              </q-btn>
            </q-item-section>
          </q-item>
          <div style="width: 100%; max-width: 97%">
            <q-scroll-area ref="scrollArea" style="width: 100%; height: 43em">
              <q-chat-message :label="currentUser.date" />
              <div v-for="mess in currentUser.messages" :key="mess.data.id">
                <q-chat-message
                  v-if="mess.sent"
                  :text="mess.data.text"
                  :sent="mess.sent"
                  bg-color="green-6"
                  text-color="white"
                />
                <q-chat-message
                  v-else
                  :avatar="currentUser.profilepic"
                  :text="mess.data.text"
                  :sent="mess.sent"
                  bg-color="primary"
                  text-color="white"
                />
              </div>
            </q-scroll-area>
            <form class="frosted q-mt-md" style="width:90%"  @submit.prevent.stop="SendMessage()">
              <q-input
                v-if="Object.entries(currentUser).length != 0"
                color="blue-9"
                filled
                v-model="message"
                style="max-width: 100%"
                label="Scrie aici"
              >
                <template v-slot:after>
                  <q-btn flat icon="send" @click="SendMessage()" />
                </template>
              </q-input>
            </form>
          </div>
        </q-card-section>
      </q-card-section>
    </q-card>
  </div>
  </q-page>
</template>

<script>
import { ref } from "vue";
import firebase from "firebase";
import { Notify } from "quasar";

export default {
  setup() {
    const scrollArea = ref(1);
    return {
      scrollArea,
      scrollbtm() {
        if (scrollArea.value) {
          scrollArea.value.setScrollPercentage("vertical", 1.1, 300);
        }
      },
    };
  },
  data() {
    return {
      message: ref(""),
      cached_users: {},
      currentUser: {},
      original_messageList: {},
    };
  },

  methods: {
    ArchiveConversation(Useruid) {
      firebase
        .database()
        .ref("adminchat/" + Useruid)
        .update({ state: false });
      delete this.cached_users[Useruid];
      Notify.create({
        icon: "mdi-archive",
        message: "Conversatia a fost arhivata.",
        timeout: 3000,
        color: "indigo-10",
      });
      this.currentUser = {};
    },
    SendMessage() {
      if (this.message.length > 0) {
        const new_message = {
          author: "Suport",
          data: {
            text: this.message,
            id: this.original_messageList.length,
          },
          sent: true,
          type: "text",
        };
        this.original_messageList.push(new_message);
        firebase
          .database()
          .ref("messages/" + this.currentUser.uid + "/messageList")
          .set(this.original_messageList);

        this.message = " ";
      }
    },
    GetChatData() {
      const db = firebase.database().ref();
      db.child("adminchat").on("value", (chats) => {
        const active_chats = chats.val();
        for (let userID in active_chats) {
          if (active_chats[userID].state) {
            // Get user profile
            const check_anon = userID.split("-");
            if (check_anon.length > 1) {
              db.child("messages/" + userID).on("value", (message_data) => {
                if (message_data.val()) {
                  const message_list = message_data.val().messageList;
                  this.original_messageList = message_data.val().messageList;
                  for (let msg in message_list) {
                    message_list[msg].data.text = [message_list[msg].data.text];

                    if (message_list[msg].author === "me") {
                      message_list[msg].author = userID;
                      message_list[msg].sent = false;
                    } else {
                      message_list[msg].sent = true;
                    }
                  }
                  const last_msg = message_list[message_list.length - 1];
                  this.cached_users[userID] = {
                    uid: userID,
                    name: userID,
                    profilepic: "https://i.imgur.com/92ibtIJ.png",
                    lastmsg: last_msg,
                    messages: message_list,
                    email: "Anonim",
                  };
                  if (Object.entries(this.currentUser).length != 0) {
                    this.currentUser = {
                      uid: userID,
                      name: userID,
                      profilepic: "https://i.imgur.com/92ibtIJ.png",
                      lastmsg: last_msg,
                      messages: message_list,
                      email: "Anonim",
                    };
                  }
                }
              });
            } else {
              // console.log(userID)
              db.child("users/" + userID)
                .get()
                .then((data) => {
                  // console.log(data.val())
                  const name = data.val().displayName;
                  const profilepic = data.val().profilepic;
                  const email = data.val().email;
                  db.child("messages/" + userID).on("value", (message_data) => {
                    if (message_data.val()) {
                      const message_list = message_data.val().messageList;
                      this.original_messageList = message_data.val().messageList;
                      for (let msg in message_list) {
                        message_list[msg].data.text = [
                          message_list[msg].data.text,
                        ];

                        if (message_list[msg].author === "me") {
                          message_list[msg].author = name;
                          message_list[msg].sent = false;
                        } else {
                          message_list[msg].sent = true;
                        }
                      }
                      const last_msg = message_list[message_list.length - 1];
                      this.cached_users[userID] = {
                        uid: userID,
                        name: name,
                        profilepic: profilepic,
                        lastmsg: last_msg,
                        messages: message_list,
                        email: email,
                      };
                      if (Object.entries(this.currentUser).length != 0) {
                        this.currentUser = {
                          uid: userID,
                          name: name,
                          profilepic: profilepic,
                          lastmsg: last_msg,
                          messages: message_list,
                          email: email,
                        };
                      }
                    }
                  });
                });
            }
          }
        }
      });
    },
    SelectUser(user) {
      this.currentUser = user;
      setTimeout(() => {
        this.scrollbtm();
      }, 500);
    },
  },
  mounted() {
    this.GetChatData();
    setTimeout(() => {
      this.scrollbtm();
    }, 500);
  },
  watch: {
    original_messageList: function () {
      // console.log("trigger")
      this.scrollbtm();
    },
  },
};
</script>

<style lang="scss">
.page-background {
  background-image: url("../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.frosted {
  background: rgba(255, 255, 255, 0.6);
  box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.37);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.18);
}
</style>